import { fontList } from '../../core/font-list';
import {colorListPairs, colorMap} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 100,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 50,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColor': {
      'default': '#7a9fd1',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconColor': {
      'default': '#cad7ee',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 0.4,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': -50,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': -250,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundX': {
      'default': 510,
      'label': 'logoBackgroundX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundY': {
      'default': 85,
      'label': 'logoBackgroundY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundRadius': {
      'default': 60,
      'label': 'logoBackgroundRadius',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundColor': {
      'default': '#FFFFFF',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBorderColor': {
      'default': '#069',
      'label': 'logoBorderColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBackgroundRadiusWidth': {
      'default': 3,
      'label': 'logoBackgroundRadiusWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 60,
      'label': 'logoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 503,
      'label': 'logoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 105,
      'label': 'logoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#222222',
      'label': 'logoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'textWidth': {
      'default': 380,
      'label': 'textWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'textX': {
      'default': 50,
      'label': 'textX',
      'type': 'number',
      'control': 'standard-number',
    },
    'textY': {
      'default': 190,
      'label': 'textY',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1X': {
      'default': 50,
      'label': 'titleTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1Y': {
      'default': 320,
      'label': 'titleTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1': {
      'default': 'Arbeitsmarkt',
      'label': 'titleTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleTextSlide1FontSize': {
      'default': 48,
      'label': 'titleTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1LineHeight': {
      'default': 1.4,
      'label': 'titleTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1FontColor': {
      'default': '#069',
      'label': 'titleTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1X': {
      'default': 50,
      'label': 'textSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1Y': {
      'default': 400,
      'label': 'textSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1': {
      'default': 'Die Arbeitslosenquote sinkt\nauf 2,9% im März 2018.',
      'label': 'textSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textSlide1FontSize': {
      'default': 32,
      'label': 'textSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1LineHeight': {
      'default': 1.4,
      'label': 'textSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'textSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1FontWeight': {
      'default': 'bold',
      'label': 'textSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': 'Arbeitslosenquote',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 20,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 54,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 32,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': 'Verlauf der letzten 30 Jahre',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line2': {
      'default': '',
      'label': 'subtitleTextSlide2Line2',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2X': {
      'default': 20,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 95,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#069',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 0,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 5,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 2,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': '%',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'Helvetica',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 24,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Helvetica',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '1',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '1988',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2018',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#0574B0'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Arbeitslosenquote'], [0.9], [0.8], [0.8], [0.8], [0.7], [0.7], [0.7], [0.7], [0.6], [0.6], [0.7], [0.7], [0.7], [0.7], [0.6], [0.6], [0.6], [0.5], [0.5], [0.5], [0.5], [0.5], [0.5], [0.6], [0.5], [0.5], [0.5], [0.5], [0.4], [0.4], [0.4], [0.5], [0.5], [0.5], [0.6], [0.7], [0.8], [0.9], [0.9], [0.9], [1.0], [1.0], [1.0], [1.1], [1.1], [1.3], [1.4], [1.6], [1.9], [2.0], [2.1], [2.2], [2.3], [2.3], [2.5], [2.6], [2.8], [3.0], [3.3], [3.6], [3.9], [4.1], [4.2], [4.3], [4.3], [4.4], [4.6], [4.7], [4.8], [4.8], [5.0], [5.1], [5.2], [5.2], [5.0], [4.9], [4.8], [4.6], [4.6], [4.5], [4.4], [4.4], [4.5], [4.5], [4.6], [4.6], [4.4], [4.3], [4.2], [4.0], [4.0], [4.0], [4.0], [4.0], [4.2], [4.3], [4.5], [4.6], [4.6], [4.5], [4.5], [4.4], [4.5], [4.5], [4.6], [4.8], [5.1], [5.3], [5.7], [5.7], [5.6], [5.5], [5.3], [5.1], [5.0], [5.0], [4.9], [4.8], [4.9], [5.0], [5.0], [4.9], [4.6], [4.2], [3.9], [3.6], [3.5], [3.4], [3.2], [3.2], [3.3], [3.4], [3.5], [3.4], [3.1], [2.9], [2.7], [2.6], [2.5], [2.4], [2.3], [2.3], [2.4], [2.5],
      [2.3], [2.2], [2.1], [1.9], [1.8], [1.7], [1.7], [1.6], [1.6], [1.6], [1.7], [1.8], [1.8], [1.8], [1.7], [1.6], [1.5], [1.5], [1.5], [1.5], [1.6], [1.7], [2.0], [2.2], [2.4], [2.4], [2.3], [2.3], [2.3], [2.3], [2.4], [2.4], [2.6], [2.8], [3.1], [3.3], [3.5], [3.6], [3.6], [3.6], [3.6], [3.6], [3.6], [3.6], [3.7], [3.8], [4.0], [4.1], [4.3], [4.2], [4.1], [3.9], [3.8], [3.7], [3.6], [3.7], [3.7], [3.7], [3.9], [4.0], [4.1], [4.1], [3.9], [3.8], [3.7], [3.6], [3.5], [3.6], [3.6], [3.7], [3.7], [3.8], [3.9], [3.8], [3.6], [3.5], [3.3], [3.1], [3.1], [3.1], [3.1], [3.1], [3.1], [3.3], [3.3], [3.2], [3.0], [2.9], [2.7], [2.5], [2.5], [2.6], [2.5], [2.6], [2.7], [2.8], [2.8], [2.7], [2.6], [2.6], [2.4], [2.3], [2.3], [2.4], [2.4], [2.5], [2.7], [3.0], [3.3], [3.4], [3.4], [3.5], [3.4], [3.6], [3.7], [3.8], [3.9], [4.0], [4.2], [4.4], [4.1], [4.0], [3.8], [3.7], [3.5], [3.3], [3.3], [3.3], [3.2], [3.2], [3.3], [3.4], [3.4], [3.3], [3.1], [2.9], [2.7], [2.6], [2.5], [2.6], [2.6], [2.7], [2.8], [3.0], [3.1], [3.1], [2.9], [2.8], [2.7], [2.7], [2.7], [2.8], [2.8], [2.9], [3.1], [3.3], [3.4], [3.4], [3.2], [3.1], [3.0], [2.9], [3.0], [3.0], [3.0], [3.1], [3.2], [3.5], [3.4], [3.3], [3.2], [3.1], [2.9], [2.8], [2.8], [2.9], [2.9], [2.9], [3.0], [3.3], [3.4], [3.3], [3.2], [3.1], [3.0], [3.0], [3.0], [3.0], [3.1], [3.1], [3.3], [3.5], [3.6], [3.6], [3.5], [3.3], [3.2], [3.1], [3.1], [3.2], [3.2], [3.2], [3.3], [3.5], [3.7], [3.6], [3.4], [3.3], [3.1], [3.0], [3.0], [3.0], [3.0], [3.0], [3.1], [3.3], [3.3], [3.2], [2.9]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColor', 'iconColor', 'iconOpacity', 'iconX', 'iconY', 'titleTextSlide1', 'titleTextSlide1Y', 'textSlide1', 'textSlide1Y'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-bfs-triptych-line-hor-steps/social.params.ts